
// 1) cardsTabs
import {
    enum_moveToOptions,
} from "../../../functions/src/shareCode/Share_S_Enum";
import {
    ass_img_avatar_p,
    ass_img_calendar_p,
    ass_img_chat_p,
    ass_img_dashboard_p,
    ass_img_edit_p,
    ass_img_info_p,
    ass_img_map_p,
    ass_img_search_p,
    ass_img_target_p,
    ass_img_puzzle2_p,
    ass_img_search_w,
    ass_img_puzzle2_w,
    ass_img_chat_w,
    ass_img_avatar_w,
    ass_img_dashboard_w,
    ass_img_calendar_w,
    ass_img_edit_w,
    ass_img_info_w,
    ass_img_cards_w,
    ass_img_map_w,
    ass_img_target_w,
    ass_img_tickets_p,
    ass_img_tickets_w,
    ass_img_playersGroup_p,
    ass_img_playersGroup_w,
    ass_img_lockText_p,
    ass_img_lockText_w,
    ass_img_ticket4_p,
    ass_img_ticket4_w,
    ass_img_articles_p,
    ass_img_articles_w,
    ass_img_document_p,
    ass_img_document_w,
    ass_img_info2_b,
    ass_warning_w,
    ass_warning_p,
    ass_img_shoppingCart_w,
    ass_img_shoppingCart_p,
    ass_img_inbox_p,
    ass_img_inbox_w,
    ass_img_inbox_g,
    ass_img_shoppingCart_g,
    ass_img_puzzle2_g,
    ass_img_articles_g,
    ass_img_avatar_g,
    ass_img_info_g,
    ass_img_dashboard_g,
    ass_img_target_g,
    ass_img_chat_g,
    ass_img_map_g,
    ass_img_calendar_g,
    ass_img_edit_g,
    ass_img_search_g, ass_img_playersGroup_g, ass_img_tickets_g, ass_img_ticket4_g, ass_img_document_g, ass_warning_g
} from "./Ass_Files";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {store_getStateValue_vo, store_var} from "../../store";

// nav_tabs
export const ass_navTabs = {

    // 1) ongoing
    ongoing_status: {
        name_byLangCode : ass_strings.oneWord_status,
        path            : enum_moveToOptions.ongoing_status,
        img             : ass_img_dashboard_p,
        selectedImg     : ass_img_dashboard_w,
        notification_n  : 0,
        showBeacon_b   : false
    },
    ongoing_questRules: {
        name_byLangCode : ass_strings.oneWord_info,
        path            : enum_moveToOptions.ongoing_questRules,
        img             : ass_img_info_p,
        selectedImg     : ass_img_info_w,
        notification_n  : 0,
        showBeacon_b   : !store_getStateValue_vo(store_var.navBar_showedBeacon_byPath_b).val[enum_moveToOptions.ongoing_questRules]
    },
    ongoing_cards: {
        name_byLangCode : ass_strings.oneWord_missions,
        path            : enum_moveToOptions.ongoing_quest_cards,
        img             : ass_img_target_p,
        selectedImg     : ass_img_target_w,
        notification_n  : 0,
        showBeacon_b   : !store_getStateValue_vo(store_var.navBar_showedBeacon_byPath_b).val[enum_moveToOptions.ongoing_quest_cards]
    },
    ongoing_chat: {
        name_byLangCode : ass_strings.oneWord_chat,
        path            : enum_moveToOptions.ongoing_chat,
        img             : ass_img_chat_p,
        selectedImg     : ass_img_chat_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    ongoing_missions: {
        name_byLangCode : ass_strings.oneWord_missions,
        path            : enum_moveToOptions.ongoing_Missions,
        img             : ass_img_target_p,
        selectedImg     : ass_img_target_w,
        notification_n  : 0,
        showBeacon_b   : !store_getStateValue_vo(store_var.navBar_showedBeacon_byPath_b).val[enum_moveToOptions.ongoing_Missions]
    },
    ongoing_map: {
        name_byLangCode : ass_strings.oneWord_map,
        path            : enum_moveToOptions.ongoing_quest_openMap,
        img             : ass_img_map_p,
        selectedImg     : ass_img_map_w,
        notification_n  : 0,
        showBeacon_b    : !store_getStateValue_vo(store_var.navBar_showedBeacon_byPath_b).val[enum_moveToOptions.ongoing_quest_openMap]
    },
    ongoing_polygonMap: {
        name_byLangCode : ass_strings.oneWord_map,
        path            : enum_moveToOptions.ongoing_quest_openMapPolygons,
        img             : ass_img_map_p,
        selectedImg     : ass_img_map_w,
        notification_n  : 0,
        showBeacon_b   : !store_getStateValue_vo(store_var.navBar_showedBeacon_byPath_b).val[enum_moveToOptions.ongoing_quest_openMapPolygons]
    },

    // 2) player
    player_explore: {
        name_byLangCode : ass_strings.oneWord_store,
        path            : enum_moveToOptions.player_store,
        img             : ass_img_shoppingCart_p,
        selectedImg     : ass_img_shoppingCart_w,
        notification_n  : 0,
        showBeacon_b   : false
    },
    player_quests: {
        name_byLangCode : ass_strings.oneWord_play,
        path            : enum_moveToOptions.player_play,
        img             : ass_img_puzzle2_p,
        selectedImg     : ass_img_puzzle2_w,
        notification_n  : 0,
        showBeacon_b    : false
    },

    player_profile: {
        name_byLangCode : ass_strings.oneWord_profile,
        path            : enum_moveToOptions.player_profile,
        img             : ass_img_avatar_p,
        selectedImg     : ass_img_avatar_w,
        notification_n  : 0,
        showBeacon_b    : false
    },

    // 3) creator
    creator_events: {
        name_byLangCode: ass_strings.oneWord_events,
        path: enum_moveToOptions.creator_events,
        img: ass_img_calendar_p,
        selectedImg: ass_img_calendar_w,
        notification_n : 0,
        showBeacon_b    : false
    },
    creator_edit: {
        name_byLangCode: ass_strings.oneWord_quests,
        path: enum_moveToOptions.creator_edit,
        img: ass_img_edit_p,
        selectedImg: ass_img_edit_w,
        notification_n : 0,
        showBeacon_b    : false
    },
    creator_profile: {
        name_byLangCode : ass_strings.oneWord_profile,
        path            : enum_moveToOptions.creator_profile,
        img             : ass_img_avatar_p,
        selectedImg     : ass_img_avatar_w,
        notification_n  : 0,
        showBeacon_b    : false
    },

    // 4) admin
    admin_quests: {
        name_byLangCode : ass_strings.oneWord_quests,
        path            : enum_moveToOptions.admin_quests,
        img             : ass_img_search_p,
        selectedImg     : ass_img_search_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_users: {
        name_byLangCode : ass_strings.oneWord_users,
        path            : enum_moveToOptions.admin_users,
        img             : ass_img_playersGroup_p,
        selectedImg     : ass_img_playersGroup_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_events: {
        name_byLangCode : ass_strings.oneWord_events,
        path            : enum_moveToOptions.admin_events,
        img             : ass_img_calendar_p,
        selectedImg     : ass_img_calendar_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_tickets: {
        name_byLangCode : ass_strings.oneWord_tickets,
        path            : enum_moveToOptions.admin_tickets,
        img             : ass_img_tickets_p,
        selectedImg     : ass_img_tickets_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_blog: {
        name_byLangCode : ass_strings.oneWord_info,
        path            : enum_moveToOptions.admin_blog,
        img             : ass_img_info_p,
        selectedImg     : ass_img_info_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_coupons: {
        name_byLangCode : ass_strings.oneWord_coupon,
        path            : enum_moveToOptions.admin_discountCoupons,
        img             : ass_img_ticket4_p,
        selectedImg     : ass_img_ticket4_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_reports: {
        name_byLangCode : ass_strings.oneWord_actions,
        path            : enum_moveToOptions.admin_reviewsReports,
        img             : ass_img_document_p,
        selectedImg     : ass_img_document_w,
        notification_n  : 0,
        showBeacon_b    : false
    },
    admin_errors: {
        name_byLangCode : ass_strings.oneWord_error,
        path            : enum_moveToOptions.admin_errors,
        img             : ass_warning_p,
        selectedImg     : ass_warning_w,
        notification_n  : 0,
        showBeacon_b    : false
    },


}



